import { PopupAuthenticator, isMsalPopupAuthenticator } from '@ms/yammer-web-authenticators';
import { CookieOptions, isUnpartitionedThirdPartyCookieSupported } from '@ms/yammer-web-support/dist/cookies';

import { setLocaleFromUserData } from '../1-main/bootstrapActions';
import { loadThirdPartyCookieRenderer } from '../3-render';

export const testCookieName = 'cookietest';
export const testCookieValue = '1';
export const sameSiteNone: CookieOptions = { sameSite: 'none' };

export const shouldRenderThirdPartyCookieDisabled = (authenticator: PopupAuthenticator) => {
  const isMsal = isMsalPopupAuthenticator(authenticator);

  return !isMsal && !isUnpartitionedThirdPartyCookieSupported();
};

export const renderThirdPartyCookieDisabled = async () => {
  const createStore = await import(/* webpackChunkName: "4-feat-create-store" */ '../1-main/createStore');
  const { store } = createStore.createYammerEmbedStore();
  const { dispatch, getState } = store;
  setLocaleFromUserData(dispatch, getState());

  const render = await loadThirdPartyCookieRenderer();
  const renderRoot = document.getElementById('root') as HTMLElement;

  render({ store, target: renderRoot });
};
